import { useEffect } from 'react';
import BreedServices from '../components/BreedServices';
import NewsLetter from '../components/NewsLetter';
import ShopAll from '../components/ourshop/Shopall';
import BreadCumbcat from '../components/shop/BreadCumb';
import NewArrivals from '../components/NewArrivals ';


function Shop() {
useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, []);
	return (
		<main>
			<BreadCumbcat/>
			<ShopAll />
			{/* <BreedServices /> */}
<div style={{ marginTop: "-100px" }}>
  <NewArrivals />
</div>
			<NewsLetter />
		</main>
	)
}

export default Shop;
